
import { Component, Vue, Prop } from "vue-property-decorator";
import TransitionMessage from "./TransitionMessage.vue";
import LaywerSignatureModal from "./LaywerSignatureModal.vue";
import EmployeeBelongingModal from "./EmployeeBelongingModal.vue";
import { profileApi } from "../services/api/profile/profile";
import { SaveCompanyProfileCommand } from "../services/api/models/SaveCompanyProfileCommand.model";
import { SaveLawyerProfileCommand } from "../services/api/models/SaveLawyerProfileCommand.model";
import { DeleteProfileLawyerSignatureCommand } from "../services/api/models/DeleteProfileLawyerSignatureCommand.model";
import { SaveEmployeeProfileCommand } from "../services/api/models/SaveEmployeeProfileCommand.model";
import { DeleteProfileEmployeeBelongingCommand } from "../services/api/models/DeleteProfileEmployeeBelongingCommand.model";

@Component({
  components: {
    TransitionMessage,
    LaywerSignatureModal,
    EmployeeBelongingModal,
  },
})
export default class AdditionalProfile extends Vue {
  @Prop() readonly profile: any;

  private errorMessageShow = false;
  private errorMessage = "";
  private profileType = "";
  private isSavingAdditionalProfile = false;
  private showProfileModal = false;
  private showCitizenProfile = false;
  private showLawyerProfile = false;
  private showEmployeeProfile = false;
  private showCompanyProfile = false;
  private showLegalPersonProfile = false;
  private showLawyerSignatureProfile = false;
  private collegiateNumber = "";
  private lawyerEmail = "";
  private lawyerVerified = false;
  private employeeEmail = "";
  private companyName = "";
  private uniqueTaxpayerRegistry = "";
  private isCitizen = false;
  private isLegalPerson = false;
  private showLaywerSignatureModal = false;
  private itemLaywerSignatureModal = {};
  private lawyerSignatures = [];
  private textLaywerSignatureModal = "Verificar";
  private showEmployeeBelongingModal = false;
  private textEmployeeBelongingModal = "verificar";
  private employeeBelongings = [];
  private showEmployeeBelongingProfile = false;
  private itemEmployeeBelongingModal = {};
  $t: any;

  async mounted() {
    await this.load();
  }

  async load() {
    let profile = this.profile;

    this.isCitizen = false;
    this.companyName = "";
    this.uniqueTaxpayerRegistry = "";
    this.collegiateNumber = "";
    this.lawyerEmail = "";
    this.lawyerVerified = false;
    this.employeeEmail = "";
    this.isLegalPerson = false;

    const citizenProfile = await profileApi.getCitizenProfile();
    this.showCitizenProfile = citizenProfile.hasProfile;
    if (citizenProfile.hasProfile) {
      this.isCitizen = citizenProfile.profileData.isCitizen;
    }

    const companyProfile = await profileApi.getCompanyProfile();
    this.showCompanyProfile = companyProfile.hasProfile;
    if (companyProfile.hasProfile) {
      this.companyName = companyProfile.profileData.name;
      this.uniqueTaxpayerRegistry =
        companyProfile.profileData.uniqueTaxpayerRegistry;
    }

    const lawyerProfile = await profileApi.getLawyerProfile();
    this.showLawyerProfile = lawyerProfile.hasProfile;
    if (lawyerProfile.hasProfile) {
      this.collegiateNumber = lawyerProfile.profileData.collegiateNumber;
      this.lawyerEmail = lawyerProfile.profileData.email;
      this.lawyerVerified = lawyerProfile.profileData.verified;
    }

    const legalPersonProfile = await profileApi.getLegalPersonProfile();
    this.showLegalPersonProfile = legalPersonProfile.hasProfile;
    if (legalPersonProfile.hasProfile) {
      this.isLegalPerson = legalPersonProfile.profileData.isLegalPerson;
    }

    const lawyerSignatureProfile = await profileApi.getLawyerSignatureProfile();
    this.showLawyerSignatureProfile = lawyerSignatureProfile.hasProfile;
    if (lawyerSignatureProfile.hasProfile) {
      this.lawyerSignatures = lawyerSignatureProfile.profileData;
    }

    const employeeProfile = await profileApi.getEmployeeProfile();
    this.showEmployeeProfile = employeeProfile.hasProfile;
    if (employeeProfile.hasProfile) {
      this.employeeEmail = employeeProfile.profileData.email;
    }

    const employeeBelongingProfile =
      await profileApi.getEmployeeBelongingProfile();
    this.showEmployeeBelongingProfile = employeeBelongingProfile.hasProfile;
    if (employeeBelongingProfile.hasProfile) {
      this.employeeBelongings = employeeBelongingProfile.profileData;
    }
  }

  async saveAdditionalProfile() {
    this.isSavingAdditionalProfile = true;

    try {
      switch (this.profileType) {
        case "citizen":
          await profileApi.setCitizenProfile();
          break;
        case "company":
          await profileApi.setCompanyProfile(
            new SaveCompanyProfileCommand(
              this.companyName,
              this.uniqueTaxpayerRegistry
            )
          );
          break;
        case "legalPerson":
          await profileApi.setLegalPersonProfile();
          break;
        case "lawyer":
          await profileApi.setLawyerProfile(
            new SaveLawyerProfileCommand(
              this.collegiateNumber,
              this.lawyerEmail,
              ""
            )
          );
          break;
        case "employee":
          await profileApi.setEmployeeProfile(
            new SaveEmployeeProfileCommand(this.employeeEmail, "")
          );
          break;
      }
    } finally {
      this.isSavingAdditionalProfile = false;
      this.showProfileModal = false;
    }

    await this.load();
  }

  async closeLaywerSignatureModal() {
    this.showLaywerSignatureModal = !this.showLaywerSignatureModal;
    await this.load();
  }

  async addLawyerSignature() {
    this.itemLaywerSignatureModal = {};
    this.showLaywerSignatureModal = true;
    this.textLaywerSignatureModal = "Guardar";
  }

  async editLawyerSignature(item: any) {
    this.itemLaywerSignatureModal = item;
    this.showLaywerSignatureModal = true;
    this.textLaywerSignatureModal = "Editar";
  }

  async deleteLawyerSignature(id: string) {
    await profileApi.deleteLawyerSignature(
      new DeleteProfileLawyerSignatureCommand(id)
    );
    await this.load();
  }

  async addEmployeeBelonging() {
    this.itemEmployeeBelongingModal = {};
    this.showEmployeeBelongingModal = true;
    this.textEmployeeBelongingModal = "Guardar";
  }

  async editEmployeeBelonging(item: any) {
    this.itemEmployeeBelongingModal = item;
    this.showEmployeeBelongingModal = true;
    this.textEmployeeBelongingModal = "Editar";
  }

  async deleteEmployeeBelonging(id: string) {
    await profileApi.deleteEmployeeBelonging(
      new DeleteProfileEmployeeBelongingCommand(id)
    );
    await this.load();
  }

  async deleteLawyer() {
    try {
      await profileApi.deleteLawyerProfile();
      await this.load();
    } catch {
      this.errorMessageShow = true;
      this.errorMessage = "Debe eliminar las firmas asociadas.";
    }
  }

  async deleteCompany() {
    await profileApi.deleteCompanyProfile();
    await this.load();
  }

  async deleteLegalPerson() {
    await profileApi.deleteLegalPersonProfile();
    await this.load();
  }

  async deleteEmployee() {
    try {
      await profileApi.deleteEmployeeProfile();
      await this.load();
    } catch {
      this.errorMessageShow = true;
      this.errorMessage = "Debe eliminar los registros asociados.";
    }
  }

  async closeEmployeeBelongingModal() {
    this.showEmployeeBelongingModal = !this.showEmployeeBelongingModal;
    await this.load();
  }

  setErrorMessage(message: any) {
    this.errorMessageShow = true;
    this.errorMessage = message;
  }
}
